import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Paper, Select, Checkbox } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { useDispatch, useSelector } from 'react-redux';

import LimitedBackdropLoading from 'components/Loading/LimitedBackdropLoading';
import { bulkAdd, resetState } from 'redux/slices/filesSlice';
import { setLoading, unSetLoading } from 'redux/slices/dataSlice';
import { filesSelector } from 'redux/selectors';
import { STATUS } from 'constants/thunkStates';
import { operationTypes } from 'constants/operationTypes';
import { Alert } from '@material-ui/lab';

const StyledPaper = styled(Paper)`
  padding: 3rem;
  width: 50vw;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

const dropzoneConfig = {
  clearOnUnmount: true,
  maxFileSize: 200000000,
  showFileNames: true,
  filesLimit: 1, // TODO: increase file upoload limit
  dropzoneText: 'Subir archivo .xlsx, .xls o .csv',
  acceptedFiles: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel', 'text/csv'
  ],
  getFileAddedMessage: (filename) =>
    `Archivo ${filename} agregado correctamente.`,
  getFileRemovedMessage: (filename) => `Archivo ${filename} eliminado.`,
  getFileLimitExceedMessage: (filename) =>
    `No es posible agregar más de un archivo por vez.`,
  getDropRejectMessage: (rejectedFile) =>
    `No es posible agregar ${rejectedFile.name}, excede los 200mb o no es del tipo esperado.`,
};

function BulkAddModal({ handleClose }) {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const { status, error } = useSelector(filesSelector);
  const [operationType, setOperationType] = useState(null);
  const [disabledSecurity, setDisabledSecuritySecurity] = useState(false);

  const handleChange = (event) => {
    setOperationType(event.target.value);
  };
  const handleChangeSecurity = (event) => {
    setDisabledSecuritySecurity(event.target.checked);
  };

  const handleUpload = () => {
    if (!files) {
      return;
    }

    dispatch(setLoading('uploadBulk'));
    const options={
      file:files[0],
      filename:files[0].name,
      operationType,
    }
    if (disabledSecurity) {
      options.disabledSecurity = disabledSecurity;
    }
    dispatch(bulkAdd(options)).then((res) => {
      if (res?.payload?.code !== 200) {
        dispatch(unSetLoading('uploadBulk'));
        handleClose();
        dispatch(resetState());
      }
      dispatch(unSetLoading('uploadBulk'));
    });
    handleClose();
  };

  return (
    <StyledPaper elevation={3}>
      <DropzoneArea {...dropzoneConfig} onChange={(files) => setFiles(files)} />
      {status === STATUS.pending && <LimitedBackdropLoading size={50} />}
      {status === STATUS.error && (error.description || error.message)}
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Checkbox
              checked={disabledSecurity}
              onChange={handleChangeSecurity}
              name="disabledSecurity"
              color="primary"
            />
          }
          label="Sin Login"
        />
      </FormControl>
      <FormControl fullWidth>
        <InputLabel>Tipo de operacion a cargar</InputLabel>
        <Select
          labelId="operationType"
          id="operationType"
          value={operationTypes[operationType]}
          label="Tipo de operación"
          onChange={handleChange}
        >
          <MenuItem value={operationTypes.master}>{operationTypes[operationTypes.master]}</MenuItem>
          <MenuItem value={operationTypes.upgrade}>{operationTypes[operationTypes.upgrade]}</MenuItem>
          <MenuItem value={operationTypes.visa}>{operationTypes[operationTypes.visa]}</MenuItem>
        </Select>
      </FormControl>
      {!operationType && <Alert severity="error">Debe seleccionar un tipo de operación</Alert>}
      <Box
        mt={3}
        p={2}
        display="flex"
        flexDirection="row"
        flexGrow={1}
        justifyContent="center"
      >
        <Box p={1}>
          <Button
            onClick={handleClose}
            fullWidth
            color="secondary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Cancelar
          </Button>
        </Box>
        <Box p={1}>
          <Button
            onClick={handleUpload}
            fullWidth
            color="primary"
            variant="contained"
            disabled={files.length < 1 || !operationType || status === STATUS.pending}
          >
            Subir archivo
          </Button>
        </Box>
      </Box>
    </StyledPaper>
  );
}

export default BulkAddModal;
